import Authenticated from './Authenticated'

export default {
    'authenticated': Authenticated
}
